import { useFormValidatedValue } from '../../taboola-common-frontend-modules/validations';

export const useCampaignGroupIdFormValidatedValue = ({
    validations,
    validationDependencies,
    initialCampaignGroupId,
    hasInitialData = false,
} = {}) => {
    return useFormValidatedValue({
        field: 'campaignGroupInfo.campaignGroupId',
        validations,
        validationDependencies,
        formFieldDependencies: { initialCampaignGroupId },
        hasInitialData,
    });
};
